import React, { useState } from 'react'
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react'

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const testimonials = [
    {
      id: 1,
      name: "Marc D.",
      age: "32 ans",
      treatment: "Greffe FUE",
      rating: 5,
      text: "J'ai retrouvé confiance en moi grâce à l'équipe de la Clinique du Grand Paris. Le résultat est parfaitement naturel et a dépassé mes attentes. Je recommande vivement cette clinique !",
      image: "/testimonials/marc-d.jpg"
    },
    {
      id: 2,
      name: "Sophie L.",
      age: "28 ans",
      treatment: "Injection lèvres",
      rating: 5,
      text: "Résultat très naturel pour mes lèvres. L'équipe est professionnelle et rassurante. Je reviendrai certainement pour d'autres traitements.",
      image: "/testimonials/sophie-l.jpg"
    },
    {
      id: 3,
      name: "David R.",
      age: "45 ans",
      treatment: "Greffe DHI",
      rating: 5,
      text: "Après des années de complexes, j'ai enfin franchi le pas. La technique DHI est impressionnante, les résultats sont bluffants. Merci à toute l'équipe !",
      image: "/testimonials/david-r.jpg"
    },
    {
      id: 4,
      name: "Emma M.",
      age: "35 ans",
      treatment: "Botox",
      rating: 5,
      text: "Très satisfaite du traitement botox. Les rides ont disparu naturellement, sans effet figé. Dr. excellent et équipe très accueillante.",
      image: "/testimonials/emma-m.jpg"
    },
    {
      id: 5,
      name: "Pierre C.",
      age: "40 ans",
      treatment: "Greffe FUE",
      rating: 5,
      text: "Intervention parfaite, suivi exemplaire. Je recommande les yeux fermés. Résultat au-delà de mes espérances après 1 an.",
      image: "/testimonials/pierre-c.jpg"
    }
  ]

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length)
  }

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length)
  }

  const goToTestimonial = (index) => {
    setCurrentIndex(index)
  }

  return (
    <section id="temoignages" className="testimonials section">
      <div className="container">
        <div className="section-header">
          <div className="header-content">
            <div className="header-text">
              <h2 className="section-title">Témoignages Patients</h2>
              <p className="section-subtitle">
                Découvrez les expériences de nos patients et leur satisfaction 
                après leurs traitements à la Clinique du Grand Paris.
              </p>
            </div>
            <div className="header-image">
              <img src="/happy-customer.jpg" alt="Patient satisfait CDGP" />
              <div className="satisfaction-badge">
                <Star size={20} fill="currentColor" />
                <span>98% Satisfaction</span>
              </div>
            </div>
          </div>
        </div>

        <div className="testimonials-container">
          <div className="testimonial-slider">
            <div className="testimonial-content">
              <div className="testimonial-card">
                <div className="quote-icon">
                  <Quote size={40} />
                </div>
                
                <div className="testimonial-text">
                  <p>"{testimonials[currentIndex].text}"</p>
                </div>

                <div className="testimonial-rating">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <Star key={i} size={20} fill="currentColor" />
                  ))}
                </div>

                <div className="testimonial-author">
                  <div className="author-image">
                    <img 
                      src={testimonials[currentIndex].image} 
                      alt={testimonials[currentIndex].name}
                    />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonials[currentIndex].name}</h4>
                    <p className="author-details">
                      {testimonials[currentIndex].age} • {testimonials[currentIndex].treatment}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="testimonial-navigation">
              <button 
                className="nav-btn prev-btn" 
                onClick={prevTestimonial}
              >
                <ChevronLeft size={24} />
              </button>
              <button 
                className="nav-btn next-btn" 
                onClick={nextTestimonial}
              >
                <ChevronRight size={24} />
              </button>
            </div>
          </div>

          <div className="testimonial-indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToTestimonial(index)}
              />
            ))}
          </div>
        </div>

        <div className="testimonials-stats">
          <div className="stat-item">
            <div className="testimonial-stat-number">98%</div>
            <div className="testimonial-stat-label">Patients satisfaits</div>
          </div>
          <div className="stat-item">
            <div className="testimonial-stat-number">4.9/5</div>
            <div className="testimonial-stat-label">Note moyenne</div>
          </div>
          <div className="stat-item">
            <div className="testimonial-stat-number">2000+</div>
            <div className="testimonial-stat-label">Avis positifs</div>
          </div>
        </div>

        <div className="testimonials-cta">
          <h3>Rejoignez nos patients satisfaits</h3>
          <p>Prenez rendez-vous dès aujourd'hui pour votre consultation gratuite</p>
          <a href="https://www.doctolib.fr/centre-laser-et-esthetique/paris/clinique-du-grand-paris" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Consultation gratuite</a>
        </div>
      </div>

      <style jsx>{`
        .testimonials {
          background: linear-gradient(135deg, #2F2F84 0%, #6466B0 100%);
          position: relative;
        }

        .section-header {
          margin-bottom: 4rem;
        }

        .header-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
          max-width: 1000px;
          margin: 0 auto;
        }

        .header-text {
          text-align: left;
        }

        .header-text .section-title {
          font-size: 3rem;
          font-weight: 700;
          color: #FFFFFF;
          background: none;
          -webkit-background-clip: unset;
          -webkit-text-fill-color: #FFFFFF;
          background-clip: unset;
          margin-bottom: 1rem;
        }

        .header-text .section-subtitle {
          font-size: 1.2rem;
          color: #FFFFFF;
          line-height: 1.6;
          font-weight: 500;
        }

        .header-image {
          position: relative;
          text-align: center;
        }

        .header-image img {
          width: 100%;
          max-width: 300px;
          height: 300px;
          object-fit: cover;
          object-position: center center;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(100, 102, 176, 0.3);
          border: 3px solid rgba(100, 102, 176, 0.3);
        }

        .satisfaction-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: linear-gradient(45deg, #6466B0, #8B6F47);
          color: #FFFFFF;
          padding: 0.75rem 1.25rem;
          border-radius: 25px;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 700;
          font-size: 0.9rem;
          box-shadow: 0 4px 15px rgba(100, 102, 176, 0.4);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        .testimonials-container {
          max-width: 800px;
          margin: 0 auto;
          position: relative;
        }

        .testimonial-slider {
          position: relative;
          margin-bottom: 2rem;
        }

        .testimonial-card {
          background: rgba(100, 102, 176, 0.1);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(100, 102, 176, 0.3);
          text-align: center;
          position: relative;
          border: 1px solid rgba(100, 102, 176, 0.2);
        }

        .quote-icon {
          color: #6466B0;
          margin-bottom: 1.5rem;
          display: flex;
          justify-content: center;
        }

        .testimonial-text {
          margin-bottom: 2rem;
        }

        .testimonial-text p {
          font-size: 1.3rem;
          line-height: 1.6;
          color: #FFFFFF;
          font-style: italic;
          font-weight: 500;
        }

        .testimonial-rating {
          display: flex;
          justify-content: center;
          gap: 0.25rem;
          margin-bottom: 2rem;
          color: #6466B0;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
        }

        .author-image {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid #6466B0;
        }

        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-info {
          text-align: left;
        }

        .author-name {
          font-size: 1.2rem;
          font-weight: 700;
          color: #FFFFFF;
          margin-bottom: 0.25rem;
        }

        .author-details {
          color: #E8EAF6;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .testimonial-navigation {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          display: flex;
          justify-content: space-between;
          pointer-events: none;
          padding: 0 -60px;
        }

        .nav-btn {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(100, 102, 176, 0.1);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border: 2px solid #6466B0;
          color: #6466B0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          pointer-events: all;
          box-shadow: 0 4px 15px rgba(100, 102, 176, 0.3);
        }

        .nav-btn:hover {
          background: linear-gradient(45deg, #6466B0, #8B6F47);
          color: #2F2F84;
          transform: scale(1.1);
          border-color: transparent;
        }

        .prev-btn {
          transform: translateX(-25px);
        }

        .next-btn {
          transform: translateX(25px);
        }

        .testimonial-indicators {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
          margin-bottom: 4rem;
        }

        .indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(136, 146, 176, 0.3);
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .indicator.active {
          background: #6466B0;
          transform: scale(1.2);
        }

        .testimonials-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
          margin-bottom: 4rem;
          text-align: center;
        }

        .stat-item {
          background: rgba(100, 102, 176, 0.1);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(100, 102, 176, 0.2);
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(100, 102, 176, 0.3);
        }

        .testimonial-stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          background: linear-gradient(45deg, #6466B0, #8B6F47);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.5rem;
        }

        .testimonial-stat-label {
          color: #E8EAF6;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .testimonials-cta {
          text-align: center;
          background: rgba(255, 255, 255, 0.1);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: #FFFFFF;
          padding: 3rem;
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(47, 47, 132, 0.3);
        }

        .testimonials-cta h3 {
          font-size: 1.8rem;
          margin-bottom: 1rem;
          background: linear-gradient(45deg, #6466B0, #8B6F47);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .testimonials-cta p {
          font-size: 1.1rem;
          margin-bottom: 2rem;
          color: #E8EAF6;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .header-content {
            grid-template-columns: 1fr;
            gap: 2rem;
            text-align: center;
          }

          .header-text {
            text-align: center;
          }

          .header-text .section-title {
            font-size: 2rem;
          }

          .header-image img {
            max-width: 250px;
            height: 250px;
          }

          .satisfaction-badge {
            top: 0.5rem;
            right: 0.5rem;
            padding: 0.5rem 1rem;
            font-size: 0.8rem;
          }

          .testimonial-card {
            padding: 2rem;
          }

          .testimonial-text p {
            font-size: 1.1rem;
          }

          .testimonial-author {
            flex-direction: column;
            text-align: center;
          }

          .author-info {
            text-align: center;
          }

          .testimonial-navigation {
            position: static;
            transform: none;
            justify-content: center;
            gap: 1rem;
            margin-top: 2rem;
          }

          .prev-btn,
          .next-btn {
            transform: none;
            position: static;
          }

          .testimonials-stats {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .testimonials-cta {
            padding: 2rem;
          }
        }

        @media (max-width: 480px) {
          .testimonial-card {
            padding: 1.5rem;
          }

          .testimonial-text p {
            font-size: 1rem;
          }

          .testimonial-stat-number {
            font-size: 2rem;
          }
        }
      `}</style>
    </section>
  )
}

export default TestimonialsSection